/**
 * @generated SignedSource<<cc6c35eac40af60a4d94265aade8f42f>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type ACLFormFields_acl$data = {
  readonly acl?: {
    readonly edges: ReadonlyArray<{
      readonly node: {
        readonly id: string;
        readonly principal: {
          readonly __typename: "User";
          readonly displayName: string | null | undefined;
          readonly email: string | null | undefined;
          readonly id: string;
          readonly key: number;
          readonly roleAssignmentPrincipal: any;
        } | {
          readonly __typename: "UserGroup";
          readonly id: string;
          readonly name: string;
          readonly roleAssignmentPrincipal: any;
        } | {
          // This will never be '%other', but we need some
          // value in case none of the concrete values match.
          readonly __typename: "%other";
        };
        readonly role: {
          readonly name: string;
        };
      };
    }> | null | undefined;
  };
  readonly id: string;
  readonly roleAssignmentTarget?: any;
  readonly " $fragmentType": "ACLFormFields_acl";
};
export type ACLFormFields_acl$key = {
  readonly " $data"?: ACLFormFields_acl$data;
  readonly " $fragmentSpreads": FragmentRefs<"ACLFormFields_acl">;
};

import ACLFormFieldsRefetchQuery_graphql from './ACLFormFieldsRefetchQuery.graphql';

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "roleAssignmentPrincipal",
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": {
    "refetch": {
      "connection": null,
      "fragmentPathInResult": [
        "node"
      ],
      "operation": ACLFormFieldsRefetchQuery_graphql,
      "identifierInfo": {
        "identifierField": "id",
        "identifierQueryVariableName": "id"
      }
    }
  },
  "name": "ACLFormFields_acl",
  "selections": [
    {
      "kind": "InlineFragment",
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "roleAssignmentTarget",
          "storageKey": null
        },
        {
          "alias": null,
          "args": [
            {
              "kind": "Literal",
              "name": "first",
              "value": 1000
            }
          ],
          "concreteType": "RoleAssignmentConnection",
          "kind": "LinkedField",
          "name": "acl",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "RoleAssignmentEdge",
              "kind": "LinkedField",
              "name": "edges",
              "plural": true,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "RoleAssignment",
                  "kind": "LinkedField",
                  "name": "node",
                  "plural": false,
                  "selections": [
                    (v0/*: any*/),
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "Role",
                      "kind": "LinkedField",
                      "name": "role",
                      "plural": false,
                      "selections": [
                        (v1/*: any*/)
                      ],
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": null,
                      "kind": "LinkedField",
                      "name": "principal",
                      "plural": false,
                      "selections": [
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "__typename",
                          "storageKey": null
                        },
                        {
                          "kind": "InlineFragment",
                          "selections": [
                            (v0/*: any*/),
                            {
                              "alias": null,
                              "args": null,
                              "kind": "ScalarField",
                              "name": "displayName",
                              "storageKey": null
                            },
                            {
                              "alias": null,
                              "args": null,
                              "kind": "ScalarField",
                              "name": "key",
                              "storageKey": null
                            },
                            {
                              "alias": null,
                              "args": null,
                              "kind": "ScalarField",
                              "name": "email",
                              "storageKey": null
                            },
                            (v2/*: any*/)
                          ],
                          "type": "User",
                          "abstractKey": null
                        },
                        {
                          "kind": "InlineFragment",
                          "selections": [
                            (v0/*: any*/),
                            (v1/*: any*/),
                            (v2/*: any*/)
                          ],
                          "type": "UserGroup",
                          "abstractKey": null
                        }
                      ],
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": "acl(first:1000)"
        }
      ],
      "type": "HasACL",
      "abstractKey": "__isHasACL"
    },
    (v0/*: any*/)
  ],
  "type": "Node",
  "abstractKey": "__isNode"
};
})();

(node as any).hash = "fe58c741b2d78d573da2532e1288fea9";

export default node;
